import { remove } from 'lodash';
import { isStaging } from '@/core/utilities';

export default class TagLookupService {
  /** @ngInject **/
  constructor(
    _,
    $http,
    ngAuthSettings,
    promiseCacheService,
  ) {
    this._ = _;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.serviceBase = ngAuthSettings.apiServiceBaseUri;
    this.promiseCacheService = promiseCacheService;
  }

  async getTagsForTimeRange(accountId, dateRange) {
    if (isStaging) {
      return import(/* webpackChunkName: "staging" */ './MockTagLookupService').then(function ({ default: mockTagLookupService }) {
        return mockTagLookupService.getTags();
      });
    }

    const url = `${this.serviceBase + accountId}/callLogs/v2/Tags/full`;
    return this.$http.post(url, dateRange).then(function handleTagsResponse(response) {
      remove(response.data.tags, (tag) => {
        return tag.tagType.toLowerCase() === 'affiliate';
      });

      return response;
    });
  }

  async getTagValues(accountId, tagType, tagName, value) {
    value = value || '';
    const url = this.serviceBase + accountId + '/callLogs/Tags/' + tagType + '/' + tagName + '/Values?val=' + encodeURIComponent(value);
    return this.promiseCacheService.getCallWithCachedPromise(url, url, 5 * 60);
  }

  async getTagValuesFromNewElasticSearch(accountId, tagType, tagName, value, dateRange) {
    if (isStaging) {
      return import(/* webpackChunkName: "staging" */ './MockTagLookupService').then(function ({ default: mockTagLookupService }) {
        return mockTagLookupService.getTagValues();
      });
    }

    value = value || '';
    const url = this.serviceBase + accountId + '/callLogs/v2/Tags/' + tagType + '/' + tagName + '/Values?val=' + encodeURIComponent(value);
    return this.$http.post(url, dateRange);
  }

  async getTagNames(accountId, viewAsPublisherId, viewAsBuyerId, tagType, value) {
    const url = this.#appendBuyerAndPublisherId(this.serviceBase + accountId + '/callLogs/Tags/' + tagType, viewAsPublisherId, viewAsBuyerId);
    return this.promiseCacheService.getCallWithCachedPromise(url, url, 10 * 60).then((response) => {
      const tagNames = response.data.values.sort().map((val) => ({ name: val, display: this._.startCase(val) }));

      if (value && value.length > 0) {
        const l = value.toLowerCase();
        return _.filter(tagNames, (ft) => ft.display.toLowerCase().indexOf(l) > -1 );
      } else {
        return tagNames;
      }
    });
  }

  async getTagTypes(accountId, viewAsPublisherId, viewAsBuyerId) {
    const url = this.#appendBuyerAndPublisherId(this.serviceBase + accountId + '/callLogs/Tags', viewAsPublisherId, viewAsBuyerId);
    return this.promiseCacheService.getCallWithCachedPromise(url, url, 60 * 60).then((response) => {
      return response.data.values.sort().map((val) => ({ type: val, display: this._.startCase(val) }));
    });
  }

  async getTagMacros(accountId, typeFilter) {
    let url = this.serviceBase + accountId + '/tags/macros';
    if (typeFilter) {
      url = url + '?type=' + typeFilter;
    }
    return this.promiseCacheService.getCallWithCachedPromise(url, url, 5 * 60);
  }

  #appendBuyerAndPublisherId(url, viewAsPublisherId, viewAsBuyerId) {
    // use a url package to manage url and querystring params
    var queryStringPrefix = url.indexOf('?') > -1 ? '&' : '?',
      returnValue = url;
    if (viewAsPublisherId) {
      returnValue += queryStringPrefix + 'affid=' + viewAsPublisherId;
    }
    if (viewAsBuyerId) {
      returnValue += (viewAsPublisherId ? '&' : queryStringPrefix) + 'byid=' + viewAsBuyerId;
    }
    return returnValue;
  }
}
